export const truckInspectionsActionConstants = {
    SAVE_QUERY_INFORMATION: 'SAVE_QUERY_INFORMATION',
    CACHE_PAGE_DATA: 'CACHE_PAGE_DATA'
};

export const requestSaveQueryInformation = queryInformation => ({
    type: truckInspectionsActionConstants.SAVE_QUERY_INFORMATION,
    queryInformation
});

export const requestCachePageData = (key, pageData) => ({
    type: truckInspectionsActionConstants.CACHE_PAGE_DATA,
    key,
    pageData
});
